import { useEffect, useState } from 'react';

function useRemSize() {
  const [remSize, setRemSize] = useState(16); // 默认值

  useEffect(() => {
    // 获取当前rem大小
    const getRemSize = () => {
      const fontSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );
      setRemSize(fontSize);
    };

    // 初始获取
    getRemSize();
    
    // 监听窗口变化，因为rem可能响应视口变化
    window.addEventListener('resize', getRemSize);
    
    return () => window.removeEventListener('resize', getRemSize);
  }, []);

  return remSize;
}

export default useRemSize